import React from 'react'

const TopicsCard = ({ topics }: { topics: string }) => {
  return (
    <div className="flex flex-wrap gap-1">
      {topics.split(',').map((topic) => {
        if (!topic) return null

        return <TopicCard key={topic} value={topic} />
      })}
    </div>
  )
}

const TopicCard = ({ value }: { value: string }) => {
  return (
    <p className="px-2 py-0.5 rounded-full bg-purple-300 text-purple-900 text-sm font-medium">
      {value}
    </p>
  )
}

export default TopicsCard
